module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_75.bbc42d45.jpg";